export default __webpack_public_path__ + "assets/images/hot_melts_2811e73812159f98bc6f096cdac62c25.jpg";